import axiosInstance from "./axiosInstance";
import { ApiResponse, BillingInfo, CaptureOrderResponse, CreateOrderResponse, SubscriptionConfirmResponse } from "./types";

/** Create the $4 one-time PayPal order */
export const createWeeklyOrder = async (amount = '4.00'): Promise<ApiResponse<CreateOrderResponse>> => {
  try {
    const res = await axiosInstance.post<CreateOrderResponse>('/payments/create-order', { amount });
    // server returns { id }
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.error || err.response?.data?.msg || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

/** Capture the PayPal order after approval (one-time) */
export const captureOrder = async (orderId: string): Promise<ApiResponse<CaptureOrderResponse>> => {
  try {
    const res = await axiosInstance.post<CaptureOrderResponse>('/payments/capture-order', { orderId });
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.error || err.response?.data?.msg || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

/** Confirm a subscription after PayPal onApprove (subscriptionID from the Buttons) */
export const confirmSubscription = async (subscriptionId: string): Promise<ApiResponse<SubscriptionConfirmResponse>> => {
  try {
    const res = await axiosInstance.post<SubscriptionConfirmResponse>('/payments/subscription/confirm', { subscriptionId });
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.error || err.response?.data?.msg || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

/** (Optional) Server-created subscription flow – not required for Buttons, but provided if you need it */
export const serverCreateSubscription = async (planId: string): Promise<ApiResponse<{ id: string; status?: string }>> => {
  try {
    const res = await axiosInstance.post<{ id: string; status?: string }>('/payments/create-subscription', { planId });
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.error || err.response?.data?.msg || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

/** Billing status for the current user (used by PricingPage) */
export const getMyBilling = async (): Promise<ApiResponse<BillingInfo>> => {
  try {
    const res = await axiosInstance.get<BillingInfo>('/billing/me');
    return { data: res.data, error: null };
  } catch (err: any) {
    const errorMessage = err.response?.data?.error || err.response?.data?.msg || err.message || 'Unknown error';
    return { data: null, error: errorMessage };
  }
};

